module.exports = __webpack_public_path__ + "img/favicon.26a2b2a.png";